import { render, staticRenderFns } from "./MiniTable.vue?vue&type=template&id=7929e7ce&scoped=true"
import script from "./MiniTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MiniTable.vue?vue&type=style&index=0&id=7929e7ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7929e7ce",
  null
  
)

export default component.exports